/*
 * 通用轮询方法
 * @param {Object} options 配置选项
 * @param {Function} options.task 需要轮询执行的任务函数，返回Promise
 * @param {Function} [options.condition] 轮询条件判断函数，返回true则继续轮询
 * @param {number} [options.interval=1000] 轮询间隔时间(毫秒)
 * @param {number} [options.maxAttempts=10] 最大轮询次数(0或Infinity表示无限轮询)
 * @param {boolean} [options.immediate=false] 是否立即执行第一次任务
 * @param {Function} [options.onSuccess] 任务成功回调
 * @param {Function} [options.onError] 任务失败回调
 * @param {Function} [options.onComplete] 轮询结束回调(无论成功或失败)
 * @returns {Object} 包含取消轮询方法的对象
 */
export function createPolling(options) {
  const {
    task,
    condition = (result) => !result,
    interval = 1000,
    maxAttempts = 10,
    immediate = false,
    onSuccess,
    onError,
    onComplete,
  } = options;

  let attempts = 0;
  let pollingId = null;
  let isCancelled = false;

  const stop = () => {
    clearTimeout(pollingId);
    isCancelled = true;
    onComplete && onComplete();
  };

  const execute = async () => {
    if (isCancelled || (maxAttempts > 0 && attempts >= maxAttempts)) {
      if (!isCancelled && maxAttempts > 0 && attempts >= maxAttempts) {
        onError && onError(new Error("Max attempts reached"));
      }
      onComplete && onComplete();
      return;
    }

    attempts++;

    try {
      const result = await task();

      if (!condition(result)) {
        onSuccess && onSuccess(result);
        onComplete && onComplete();
        return;
      }

      if (
        (maxAttempts === 0 ||
          maxAttempts === Infinity ||
          attempts < maxAttempts) &&
        !isCancelled
      ) {
        pollingId = setTimeout(execute, interval);
      } else {
        if (!isCancelled) {
          onError && onError(new Error("Max attempts reached"));
        }
        onComplete && onComplete();
      }
    } catch (error) {
      onError && onError(error);
      onComplete && onComplete();
    }
  };

  if (immediate) {
    execute();
  } else {
    pollingId = setTimeout(execute, interval);
  }

  return { stop };
}

export class VideoHandleTimer {
  constructor() {
    this.totalSeconds = 0;
    this.timer = null;
    this.isActive = false;
  }

  start(callback) {
    if (!this.isActive) {
      this.isActive = true;
      this.timer = setInterval(() => {
        this.totalSeconds++;
        if (callback) callback(this.totalSeconds);
      }, 1000);
    }
  }

  stop() {
    if (this.isActive) {
      clearInterval(this.timer);
      this.isActive = false;
      return this.totalSeconds;
    }
    return 0;
  }
  reset() {
    this.stop();
    this.totalSeconds = 0;
  }
  //秒
  getTime() {
    return this.totalSeconds;
  }
}
